import React from 'react'
import pdf1 from '../assets/files/DraftPlanDocuments/Imagine Burleson 2020 Midpoint Update (2020.10.20 DRAFT).pdf'
import pdf2 from '../assets/files/DraftPlanDocuments/Future Land Use Map (2020.10.20 DRAFT).pdf'
import pdf3 from '../assets/files/DraftPlanDocuments/Imagine Burleson 2010 Comprehensive Plan (Adopted April 2010).PDF'

export default function DraftPlanDocs() {
    return (
        <div>
            <main role="main" className="flex-shrink-0 modular min-vh-100 my-5">
                <div className='container my-5 pt-5'>
                    <div className="row text-start">
                        <h1>Draft Plan Documents</h1>
                    </div>
                    <div className="row text-start">
                        <ul>
                            <li><a href={pdf1} target="_blank">Draft Imagine Burleson Comprehensive Plan 2020 Midpoint Update</a></li>
                            <li><a href={pdf2} target="_blank">Draft Future Land Use Map</a></li>
                            <li><a href={pdf3} target="_blank">Adopted Imagine Burleson Comprehensive Plan (Original 2010 Plan)</a></li>
                        </ul>
                    </div>
                </div>
            </main>
        </div>
    )
}
